/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum CIColors {
  Primary = '#153558',
  Secondary = '#4ec1ec',
  Tertiary = '#3880ad',
  GraphicElements = '#9c9b9b',
  GraphicElementsHover = '#7d7c7c',
  Success = '#00c505',
  Text = '#40424a',
  Error = '#b94141',
  Warning = '#f1ad42',
}

export enum CIFonts {
  Text = 'Roboto,sans-serif',
  Code = 'Source Code Pro',
}
